module.exports = __webpack_public_path__ + "static/media/FoxWallet.e54e68f3.png";